import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { Ispettorato } from 'src/app/models/ispettorato';
import { IspettoratoService } from 'src/app/services/ispettorato.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { IspettoratiFormComponent } from './dialogs/form/form.component';

@Component({
  selector: 'ispettorati',
  templateUrl: './ispettorati.component.html',
  styleUrls: ['./ispettorati.component.scss']
})
export class IspettoratiComponent implements OnInit {

  headingText: string = 'Ispettorati';


  relations: string[] = ['compagnia', 'comune', 'comune.provincia'];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'ID',
        internalName: 'id',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Codice',
        internalName: 'codice',
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Compagnia',
        internalName: 'compagnia',

        displayFunction: (model) => model.compagnia?.nome,
        sortDisabled: true,
      }
    ),

    new dataTableColumnDefinition(
      {
        humanName: 'Indirizzo',
        internalName: 'fullAddress',
        sortDisabled: true,

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Telefono',
        internalName: 'tel',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Cellulare',
        internalName: 'cell',

      }
    ),

    new dataTableColumnDefinition(
      {
        humanName: 'Fax',
        internalName: 'fax',

      }
    ),

    new dataTableColumnDefinition(
      {
        humanName: 'Email',
        internalName: 'email',

      }
    ),

  ];
  constructor(public ispettoratoService: IspettoratoService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<IspettoratiComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona un ispettorato';
    }
    if (this.data?.defaultSearch) {
      this.search = this.data.defaultSearch;
    }
  }

  async ngOnInit() {

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (ispettorato: Ispettorato) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare l'ispettorato ${ispettorato.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.ispettoratoService.delete(ispettorato);
          this.toast.success('Ispettorato eliminato.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione ispettorato fallita.", "Errore!");
    }
  }



  editFunction = async (ispettorato: Ispettorato) => {
    try {
      let dialogRef = this.dialog.open(IspettoratiFormComponent, { data: ispettorato });
      dialogRef.afterClosed().subscribe(async (data: Ispettorato) => {
        if (data) {

          Object.assign(ispettorato, data);

          await this.ispettoratoService.edit(ispettorato);

          this.toast.success('Ispettorato modificato');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica ispettorato fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(IspettoratiFormComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(ispettorato?: Ispettorato) {
    if (ispettorato) {
      try {
        await this.ispettoratoService.create(ispettorato)
        this.toast.success('Ispettorato creato!')
      }
      catch (e) {
        this.toast.error('Creazione ispettorato fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }

}
